import { Input, List, Row, Space, Typography } from "antd"
import PageSidebar from "../common/PageSidebar"
import VSpace from "../common/VSpace"
import { usePropertyInvalidator, usePropertyListQuery } from "./propertyQueries"
import ThemableButton from "../Items/ThemableButton"
import { useContext, useState } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowLeft, faRotate } from "@fortawesome/pro-solid-svg-icons"
import { grey } from "@ant-design/colors"
import "./PropertiesSidebar.css"
import SidebarCreateButton from "../common/SidebarCreateButton"
import EditPropertyContext from "./EditPropertyContext"
import PropertiesSidebarItem from "./PropertiesSidebarItem"
import { filterProperties } from "./propertyModel"
import { useCustomerQuery } from "../customers/customerQueries"

const { Text, Link } = Typography

const PropertiesSidebar = () => {
  const { customerId, selectProperty, showDeletedView } = useContext(EditPropertyContext)

  const propertiesQuery = usePropertyListQuery(customerId, showDeletedView)
  const customerQuery = useCustomerQuery(customerId!)
  const invalidator = usePropertyInvalidator()
  const [search, setSearch] = useState('')

  const filteredProperties = filterProperties(propertiesQuery.data ?? [], search)

  return <PageSidebar>
    <VSpace size="large">
      <VSpace style={{padding: '10px 10px 0 10px'}}>
        <Row justify="space-between" align="middle">
          <Space>
            {!showDeletedView && <Link style={{color: 'white'}} href={`#!/customers#${customerQuery?.data?.url}`}><FontAwesomeIcon icon={faArrowLeft}/></Link>}
            <Text style={{ color: 'white', fontSize: 18, fontFamily: 'Open Sans, sans-serif'}}>{showDeletedView ? 'DELETED' : ''} Properties</Text>
          </Space>
          <ThemableButton type="link" colorLink={grey[2]}
            icon={<FontAwesomeIcon icon={faRotate} />}
            onClick={() => invalidator.invalidatePropertyList(customerId)}
          />
        </Row>
        <Row>
          <Input.Search placeholder="Search" value={search} onChange={x => setSearch(x.target.value ?? '')} allowClear />
        </Row>
      </VSpace>

      {!showDeletedView && <SidebarCreateButton text="Add New Property" onClick={() => selectProperty(0, false)} />}

      <div className="react-scrollable-list" style={{
        height: `calc(100vh - ${showDeletedView ? 110 : 192}px)`
      }}>
        <List
          loading={propertiesQuery.isFetching}
          dataSource={filteredProperties}
          rowKey={property => property.id}
          renderItem={property => <PropertiesSidebarItem property={property} />}
        />
      </div>
    </VSpace>
  </PageSidebar>
}

export default PropertiesSidebar